import MyBookingsPage from './MyBookingsPage';

export default MyBookingsPage;
